(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 1840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(8074);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./src/landingPage/views/About/About.module.less
var About_module = __webpack_require__(4898);
var About_module_default = /*#__PURE__*/__webpack_require__.n(About_module);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/index.jsx + 10 modules
var Hero = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/landingPage/components/Section/index.jsx + 17 modules
var Section = __webpack_require__(1699);
;// CONCATENATED MODULE: ./src/landingPage/assets/team/jake.png
/* harmony default export */ var jake = ({"src":"/_next/static/media/jake.a22430d7.png","height":421,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAUVBMVEVMaXFtfYGhqqq+vLyIeXO4l44xN0pWTEkmHyljh3qTd248OUNHPSiCXVE7Jh+ikZFRZH4WGCtRZHxmZmsYExVlUUudnJfw4Ny5o6E7R15EVXXbEeeBAAAAFHRSTlMAQXvWw/7+N/4K+5wZ6+nZtf1U350TsCsAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA7SURBVHicHcdJEoAgDADBUQETN1CDoP9/qAWnrgZ0UAB1z9icfZm6S43Nbfeu/8j3BatYDm9CzOQM3w8rJQHcvLmBogAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/mark.png
/* harmony default export */ var mark = ({"src":"/_next/static/media/mark.040e3f3d.png","height":360,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVRUVF8Xlm8lofYoJRPSk0/NTc2MTZmVFgyMjxMQkj/39IRFCmjh4E+QVHZopOKh5Pmq5knKjiNfIFIS2Dcwr+lrcHouKs0N0qbenHwxbf0uq7j5Ot0eI1HOzrcr59GSl72+P9cqBPkAAAAFnRSTlMBmviEYNKHHZ5E+klRuO3mtOqU/v77XR1RowAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEJJREFUeJwVxkUWwCAQBNGOAjGiM1jk/qfM69rUB2C624L1oQ4tUcnwOKKJaTHEJGnlRx9lBzBryWfZHF498nep/QFR8gMFI6nl4wAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/nicole.png
/* harmony default export */ var nicole = ({"src":"/_next/static/media/nicole.2309a563.png","height":387,"width":356,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAY1BMVEVMaXFGNyt3goloYlfUxLpaSC9JPzVtdHhdYV59kbt1gJRnY1g/RVRmUzPgwK5OQTSDYkVKQj9FQkFzc39pdoQfICiFcFueiHqupJqIhIMtMDxsXU2jg2SXgWsxLy9eTkmKna0XM2SvAAAAFXRSTlMA/onQ+fn+JlMMXa+F1/yg/cbqFqpsqT8KAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVR4nAXBBwKAIAwAsUOZLlwtbv3/K02AWAWAZt/qBLTFnhFSf1vNENw16ATBu9HMC91j1MvKIW8R+X5D3QLCD+yNmAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/anna.png
/* harmony default export */ var anna = ({"src":"/_next/static/media/anna.6815162c.png","height":370,"width":355,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAXVBMVEWFl298LYY5QTmMhH+UzomelpR1K3uQI5lBTU1RWlqfkZHLtbVgV06ciY9EC1XRtbW1pqR1QX1tD3vY0sCtdqOSO5jj1NLUv8Hr496eUJ/jxsR2L359OoTn2c/evNn8ewfuAAAAGXRSTlMB5KOaDfth/h/AroDbJ7bwp4Dpmv39///+IPYi6AAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEBJREFUeJwdxlcSgCAQBcFHXIJiQAmm+x/TYudnGoDz3mGkipGM0OrEiFdZGfNSt3GbTN8toMV9EH0ZWjwn9fb+QC8CXyqzADgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/scott.png
/* harmony default export */ var scott = ({"src":"/_next/static/media/scott.599721e3.png","height":242,"width":204,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAXVBMVEVMaXEsHRHRm4SbfG0vNEgkKTkNDx4TCgoaDgjEkn9nPy5TPC5DLSG5kXzjppBEMyurd2MnKUS5ra5fYXArLkU3O1s9P0hcOiysnJaPYVDBno/dqZOkbV7Kz9SVlp1q8r2aAAAAFHRSTlMAcur99THCBzv91NyXxi7PXNf+dm31imoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA/SURBVHicJclJEoAgDADBcQ24IZjg7v+faVme+tAgQ18AOO9XB8zn71RenXwx7kFAlqPKbUO0tGWtMbsfVX0BQDgCnDJWP5YAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/julien.png
/* harmony default export */ var julien = ({"src":"/_next/static/media/julien.05ed8c5b.png","height":1282,"width":986,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAASFBMVEULDxIlKilwZFSJjIU6PjOFiY1xemkCBQmcl4lQVk61r6J9ZVFlWkprbGyGc2R9gYOTi347KBvCwLZvSTPe4N2ofWSmd1fQn38cLdj2AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nBXBiRGAIAwAwQMCSQBFwaf/Th13serBhWq9SWEezxsTl627F5KcLTho3PnlrICOTfkAMHgBhqtTM8gAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/chris.png
/* harmony default export */ var chris = ({"src":"/_next/static/media/chris.446ff4d2.png","height":1804,"width":1290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAUVBMVEVyeIOnhW7WsZVmYGG4jFmwknHJonm9l3XOrYa4kWi5gGSfdlxfZG59goxrb3mOkZncvpq3j3mrhFSOeFtKUF1janc0NjzOjGzes3qCZlW2nog7ujeXAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOElEQVR4nAXBBwKAIAwAsWO2bHDr/x9qgqgP0SOhmPggZlmdpJSzVba93N/Ene7tgwMYnavSWv0BMWwB9wsxnKYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/assets/team/aoife.png
/* harmony default export */ var aoife = ({"src":"/_next/static/media/aoife.bd494de9.png","height":258,"width":242,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEVMaXGjjXnTtp+gg2zDrZari25wX06BZVDatJxeQS+2loT//+5OPSqfhG+2oIq9oYPYqpCfjGzjzbXuzbu9m4SwjXTavKqylHzrHtptAAAAFXRSTlMA9Jf8ZEOT/Pw4jS5buteR+iiB/f5ynIKyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVR4nB3IWRKAIAzA0LC24q4F739Tp+TrTQC2hVkVmbrDO6ojS+q74+yXHo74qYUVeJKaZV8ltgI/M/gBjn+kCIcAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/About/components/LocationMap.module.less
var LocationMap_module = __webpack_require__(25093);
var LocationMap_module_default = /*#__PURE__*/__webpack_require__.n(LocationMap_module);
;// CONCATENATED MODULE: ./src/landingPage/views/About/components/LocationMap.jsx



function LocationMap() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1202",
        height: "720",
        viewBox: "0 0 601 360",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                id: "earth_a",
                x: "0",
                y: "0",
                width: "7.7",
                height: "7.7",
                patternUnits: "userSpaceOnUse",
                patternContentUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "#5140B3",
                    fillOpacity: ".5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "1",
                            cy: "1",
                            r: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                            cx: "4.85",
                            cy: "1",
                            r: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(1.93 3.85)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "-2.85",
                                    cy: "1",
                                    r: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "1",
                                    cy: "1",
                                    r: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "4.85",
                                    cy: "1",
                                    r: "1"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("mask", {
                id: "earth_b",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0 0h601v360H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        fillRule: "evenodd",
                        fill: "#fff",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M0 26h2l.5-1h1l.5-1h2l1-2h-.5L6 21H5l-.5-1H5l1.5-3H5l-.5-1H5l.5-1H7l.5 1H8l.5-1H8l-.5-1H8l.5-1H11l-1.5-3H13l.5-1h1l.5-1h2.5l.5 1h1l1 2h2l1 2h2.5l.5-1h.5l.5 1h.5l1.5-3h1l.5-1h2l1-2H32l-.5-1H34l.5-1h3l.5-1h1.5l.5 1h.5l.5-1h1.5l.5 1h.5l1-2h1l.5-1h2l.5-1H48l-.5-1h8L57 3h3.5l.5-1h5.5l.5 1h1l1.5 3h1l1 2H70l-1.5 3h.5l.5 1H68l-.5 1h1l-1 2h1l-.5 1h-1l-.5 1h1l-.5 1h-1l-.5 1h1L65 22h-3l-1 2h-2l-2 4h-2.5l-.5-1h-1l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1h.5l.5-1H53l-.5-1H54l.5-1H54l-.5-1h.5l.5-1H52l-.5-1h-1l-1-2h.5l.5-1h-1L48 12h-1.5l1 2h-1l.5 1h1l.5 1h-1l.5 1h1l.5 1h-1l1.5 3h1.5L50 24h-1.5l1 2h-2l2 4H49l-.5 1H50l1.5 3H51l-.5 1h1l-1 2h-2l-.5 1h-2l-.5 1h-2l-.5 1h-1l-1 2h-1l-.5 1h1l-.5 1h-1l-1 2h-1l-.5 1h3l-1 2h2l-1 2H42l.5 1H45l-.5 1h-8L35 56h3l.5-1h6l1-2h.5l.5 1h.5l-1.5 3H47l.5 1h2l.5 1h1.5l-1 2H54l.5 1h1l.5 1h2.5l-1 2h1L57 68h-1l-.5 1h1l-1 2h1l-1 2h-2l-.5 1h-1l-.5 1h1L51 78h-1l-2 4h-1l-2 4h.5l1 2h-2l1.5 3h1.5l-.5 1h-1l-.5 1H44l-.5-1h-1l-2-4h.5l.5-1h-2l1-2h-1l1-2h-1l1-2h-1l2-4h-1l1-2h-1l1-2h-1l1-2H40l-1-2h-1l-2-4h-1.5l1-2h-1l1.5-3h1.5l-1-2h-2l-.5-1h-1l-1-2h-2l-.5-1h-2l-.5-1h-2l-1.5-3h-2l-2-4h.5l.5-1H19l-1.5-3h.5l.5-1h-2l1-2h-1l2-4h-1l.5-1h1l.5-1h-2l1-2H17l-1.5-3H17l.5-1h-2l1-2h-1l1-2h-5l-.5 1h-1l-.5 1h-3L6 26H3l-.5 1h-3zm35.5-16H37l-.5 1H36zm-7 3h2l-1 2H29l-1-2m9 2h1.5l-.5 1h-.5zm6 5h.5l.5 1h1.5l-.5 1h-2l-.5 1h-1zm8-13h1l.5 1h-1zM37 24h1l.5-1h.5l1 2h1l1 2h-.5L40 30h-1.5l-.5-1h-1l-1.5-3h.5zm8 1h1.5l-.5 1h-.5zM33 46h.5l.5 1h1.5L34 50h-3.5l1 2h-1l-.5-1h-1.5l1-2h-1l.5-1h1l.5-1h2zm1.5 5h3l-1 2h-3z",
                                transform: "matrix(3.85 0 0 3.85 0 -.96)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M64.5 23h5l-1 2h.5l.5 1h-5l-1-2h.5zM79.5 7h.5l.5 1h1l1 2H82l-.5 1h1l-1 2h-1l-.5 1h-1.5L77 11h-1.5l1-2h1l.5-1h1zM89 4h3.5l1 2H92l-.5 1h1L92 8h-3l-.5 1H88l-.5-1h-1l-1-2H88zM100 2h1.5l.5 1h1l.5 1h2l.5 1h2l1 2h3.5l-1 2h2l-.5 1h3l.5-1h2.5l1 2h1.5l.5-1h1.5l-.5-1h-1l-.5-1h-.5l-.5 1h-1l1-2h-3l1.5-3h5.5l1 2H122l-.5 1h2.5l.5 1h3l.5 1h1.5l.5-1h.5l.5 1h3.5l.5-1h2l.5-1h3.5l.5 1h4l.5 1h1.5l-1 2h1l-.5 1h-2.5l2 4h-.5l-2 4h-1.5l1 2h-1l1 2h-.5l-.5 1h2l-.5 1h-1.5l1 2h-1l1 2H142l-.5 1h-.5l-.5-1h1l-3-6h1l-1-2h.5l1-2h-2.5l1 2h-.5l-.5 1h-3l-.5 1h-1l-.5 1h1l-1 2h4l-1 2h2l-1 2h2l-1 2h1l-1 2h-2l-1 2h-1l-1 2h.5l1 2h1.5l1.5-3h-.5l-1-2h1.5l.5-1h1l.5-1h1l.5-1h1l-3 6h1l-1 2h1l-.5 1h-1l-1 2h-2.5l1 2h-.5l-1 2h-1l1-2h.5l-1-2h-1l-.5-1h-1.5l1-2h-1l-1 2h.5l1 2h.5l-1 2h1l-1 2h1l-1 2h2l-.5 1h-.5l1.5 3h1.5l-1 2h2l-.5 1h-1.5l.5 1h1l1 2h3l.5 1h4l.5 1h.5l.5-1h1.5l.5 1h1l1 2h2.5l-1 2H149l-1-2h-1.5l-1 2H143l-.5-1h-1l2.5 5h1.5l-1 2h2l-1 2h1l-1 2h1l-1.5 3h-1l-.5 1h1l-.5 1h-1l-1.5 3h1l-.5 1h-1l-.5 1h-2l1-2h-.5l-1-2h-1l-2-4h-2.5l-.5 1h-5.5l-1-2h2l-2-4h.5l1-2h1l.5-1h1l.5-1h1l1-2h3.5l-1-2h-.5l-.5 1H130l-.5-1h-5l-.5-1h-1l-1-2h-2.5l1-2h-.5l-2-4h1l.5 1h1l-1-2h.5l.5-1h-.5l-.5-1h-1l-1.5-3h-1.5l-.5 1h-1l-1 2h-1.5l2 4h-.5l-.5 1H111l-1-2h-1.5l1-2h-2l1-2h-.5l-1-2h-1l-1-2h-2.5l-1 2h1l-.5 1h-1l-1 2h-2l-.5 1h3l-.5 1h-1l-2 4h-1l-1 2h-1l-1.5 3h.5l.5 1H95l-.5 1h-1l-1 2h1l-.5 1h-1l-1.5 3h1l-.5 1h-2.5l1 2h-2l1 2h-3l.5 1h-4l-1.5-3h1l-.5-1h-1.5l1-2H80l-1.5-3h1l-1-2h1l-.5-1h1l-3-6h1l-.5-1h-1l-.5-1h-4.5l-.5 1h-.5l-.5-1h-2l-1-2h-1.5l1-2h-2l2-4h-2l.5-1h1l.5-1h-1l.5-1h1l.5-1h1l1-2h-1l.5-1h1l.5-1h-2l1-2h-1l1.5-3h1.5l.5 1h1l-1-2h-1.5l1-2h-3l1-2h-1l.5-1h1.5l-1-2h.5l.5-1h3l-1 2h2l-1 2h2l.5-1h1.5l-.5-1h-1l-1.5-3h1l-1-2H76l1-2h1.5l-1-2h.5l1-2h2l.5-1H86l.5 1h1l.5 1h.5l.5-1h2l1.5-3h-1l1-2h-1l1.5-3h1l1-2h1.5l1 2H96l-2.5 5H95l.5 1h1l.5 1h1l-1-2h.5l1-2h-1l.5-1h3l1-2h-1l-.5 1h-1l1-2h2l.5-1h1.5l-1-2h2l-.5-1h-2l-.5-1h-2l-1-2h1l-1-2zm1.5 6h1l.5 1h-1zM92 19h3l.5 1h-3zm-11 8h1l.5 1h-1zm0 4h1l.5 1h-1zm-5.5 9h1l1 2h-1zm3.5 1h1l.5 1h-1zm7.5-3h1l1 2h-1zM81 43h3l.5 1h3l.5 1h-8l-1-2h1l.5 1h1zm9-4h1l.5 1h-1zm26.5 15h1l1 2h-.5l-.5 1h-1l.5-1h.5zm10-4h3l1 2h-1l1 2h-1l1 2h-2l1 2H128l-1 2h-1l.5-1h-1l-1 2h.5l.5 1h-1l-1-2h1l-1-2h.5l.5-1h1l1-2h-1l1-2h-1l.5-1h1.5zm3.5 7h1l.5 1h-1zm1 2h2l.5 1h-2zm2 2h1l.5 1h-1zm-8 2h2l.5 1h-2zm2.5 1h2l.5 1h-2zm5 0h3l1 2h-1l-.5-1h-2zm5.5 0h.5l1 2h1.5l-1.5 3h-1l1-2h-3zm3.5-10h1l.5 1h-1zm10 14h1l.5 1h1.5l-1 2h1l-1.5 3h-.5l-.5-1h-1.5l1-2h.5l.5 1h1m0 9h2l-1 2h2l-2 4h-1l-.5 1h-1l-1.5 3h-3l1-2h-.5l-.5-1h2.5l1-2h1l1.5-3h-1zM95 67h3.5l-1 2h1l-.5 1h-1l-.5 1h1L96 74h-1.5l-.5-1h-1l-.5-1h2l-1-2h1l-1-2h2",
                                transform: "matrix(3.85 0 0 3.85 0 -.96)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                id: "earth_mask_signal",
                className: (LocationMap_module_default()).Earth_mask_signal,
                x: "0",
                y: "0",
                width: "1",
                height: "720",
                fill: "#5140B3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "100%",
                height: "100%",
                fill: "url(#earth_a)",
                mask: "url(#earth_b)",
                transform: "scale(.999 1.0077)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#earth_filter0_d)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_0",
                        className: (LocationMap_module_default()).Earth_point_0,
                        x: "100",
                        y: "78",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint0_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_0),
                        cx: "105",
                        cy: "83",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_1",
                        className: (LocationMap_module_default()).Earth_point_1,
                        x: "163",
                        y: "130",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint1_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_1),
                        cx: "168",
                        cy: "135",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_2",
                        className: (LocationMap_module_default()).Earth_point_2,
                        x: "163",
                        y: "332",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint2_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_2),
                        cx: "168",
                        cy: "337",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_3",
                        className: (LocationMap_module_default()).Earth_point_3,
                        x: "300",
                        y: "110",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint3_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_3),
                        cx: "305",
                        cy: "115",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_5",
                        className: (LocationMap_module_default()).Earth_point_5,
                        x: "370",
                        y: "175",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint5_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_5),
                        cx: "375",
                        cy: "180",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_6",
                        className: (LocationMap_module_default()).Earth_point_6,
                        x: "425",
                        y: "180",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint6_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_6),
                        cx: "430",
                        cy: "185",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_7",
                        className: (LocationMap_module_default()).Earth_point_7,
                        x: "470",
                        y: "235",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint7_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_7),
                        cx: "475",
                        cy: "240",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_8",
                        className: (LocationMap_module_default()).Earth_point_8,
                        x: "521",
                        y: "278",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint8_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_8),
                        cx: "526",
                        cy: "283",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_9",
                        className: (LocationMap_module_default()).Earth_point_9,
                        x: "271",
                        y: "125",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint9_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_9),
                        cx: "276",
                        cy: "130",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_10",
                        className: (LocationMap_module_default()).Earth_point_10,
                        x: "291",
                        y: "135",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint10_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_10),
                        cx: "296",
                        cy: "140",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_11",
                        className: (LocationMap_module_default()).Earth_point_11,
                        x: "521",
                        y: "148",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint11_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_11),
                        cx: "526",
                        cy: "153",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_12",
                        className: (LocationMap_module_default()).Earth_point_12,
                        x: "581",
                        y: "328",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint12_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_12),
                        cx: "586",
                        cy: "333",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_13",
                        className: (LocationMap_module_default()).Earth_point_13,
                        x: "331",
                        y: "125",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint13_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_13),
                        cx: "336",
                        cy: "130",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_14",
                        className: (LocationMap_module_default()).Earth_point_14,
                        x: "470",
                        y: "205",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint14_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_14),
                        cx: "475",
                        cy: "210",
                        r: "10px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        id: "earth_point_15",
                        className: (LocationMap_module_default()).Earth_point_15,
                        x: "495",
                        y: "230",
                        width: "10",
                        height: "10",
                        rx: "5",
                        fill: "url(#earth_paint15_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        className: (0,clsx_m/* default */.Z)((LocationMap_module_default()).Pulse, (LocationMap_module_default()).Pulse_15),
                        cx: "500",
                        cy: "235",
                        r: "10px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "earth_filter0_d",
                        x: "0",
                        y: "0",
                        width: "1202",
                        height: "720",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint0_linear",
                        x1: "118",
                        y1: "132",
                        x2: "145.4493",
                        y2: "84.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint1_linear",
                        x1: "181",
                        y1: "184",
                        x2: "208.4493",
                        y2: "136.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint2_linear",
                        x1: "181",
                        y1: "386",
                        x2: "208.4493",
                        y2: "338.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint3_linear",
                        x1: "318",
                        y1: "164",
                        x2: "345.4493",
                        y2: "116.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint5_linear",
                        x1: "388",
                        y1: "229",
                        x2: "415.4493",
                        y2: "181.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint6_linear",
                        x1: "443",
                        y1: "234",
                        x2: "470.4493",
                        y2: "186.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint7_linear",
                        x1: "488",
                        y1: "289",
                        x2: "515.4493",
                        y2: "2141.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint8_linear",
                        x1: "540",
                        y1: "332",
                        x2: "566.4493",
                        y2: "284.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint9_linear",
                        x1: "310",
                        y1: "179",
                        x2: "336.4493",
                        y2: "131.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint10_linear",
                        x1: "330",
                        y1: "189",
                        x2: "356.4493",
                        y2: "141.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint11_linear",
                        x1: "540",
                        y1: "202",
                        x2: "566.4493",
                        y2: "154.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint12_linear",
                        x1: "620",
                        y1: "382",
                        x2: "646.4493",
                        y2: "334.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint13_linear",
                        x1: "370",
                        y1: "179",
                        x2: "396.4493",
                        y2: "131.71423",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint14_linear",
                        x1: "488",
                        y1: "289",
                        x2: "515.4493",
                        y2: "241.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "earth_paint15_linear",
                        x1: "503",
                        y1: "314",
                        x2: "540.4493",
                        y2: "266.71432",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78F5DE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9AF7E6"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx + 2 modules
var SecurityBadges = __webpack_require__(69753);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/BottomCta.jsx
var BottomCta = __webpack_require__(72062);
;// CONCATENATED MODULE: ./src/landingPage/views/About/About.jsx

















var About = function() {
    var execTeam = [
        {
            name: "Jake Moore",
            role: "Chief Revenue Officer",
            img: jake,
            linkedin: "https://www.linkedin.com/in/jakeotismoore/"
        },
        {
            name: "Scott Albin",
            role: "Chief Strategy Officer",
            img: scott,
            linkedin: "https://www.linkedin.com/in/scottalbin/"
        },
        {
            name: "Chris Hyde",
            role: "Chief Information Officer",
            img: chris,
            linkedin: "https://www.linkedin.com/in/chris-hyde-6787623/"
        },
        {
            name: "Anna Bondarenko",
            role: "Chief Operating Officer",
            location: "Dubai, United Arab Emirates",
            img: anna,
            linkedin: "https://www.linkedin.com/in/annabonda/"
        },
        {
            name: "Nicole DeMaise",
            role: "Chief Legal Officer",
            img: nicole,
            linkedin: "https://www.linkedin.com/in/nicole-demaise-81a0a5191/"
        },
        {
            name: "Mark Hookey",
            role: "Founder and Chief Executive Officer",
            img: mark,
            linkedin: "https://www.linkedin.com/in/markhookey/"
        },
        {
            name: "Julien Bonnier",
            role: "VP of Product",
            img: julien,
            linkedin: "https://www.linkedin.com/in/julienbonnier/"
        },
        {
            name: "Aoife Fallon Lee",
            role: "Head of Finance",
            img: aoife,
            linkedin: "https://www.linkedin.com/in/aoife-fallon-lee-aca-ba28a737/"
        }, 
    ];
    var locations = [
        {
            city: "New York",
            address: "149 E 23rd Street, Suite 2035",
            address2: "New York, NY 10010"
        },
        {
            city: "Australia",
            address: "Suite 902 (Level 9), 146 Arthur Street",
            address2: "North Sydney, NSW 2060"
        },
        {
            city: "Singapore",
            address: "9 Raffles Place, #26-01, Republic Plaza",
            address2: "Singapore 048619"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* Hero */.VM, {
                background: "violet-1000",
                withStarsAnimation: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* HeroCol */.Zx, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroTitle */.LR, {
                            children: "Unlock the power of external data"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroSubtitle */.RV, {
                            children: "Demyst believes that external data is the next frontier of business impact, yet it is often locked away. Organizations want to harness more value from the extensive external data ecosystem and meet their data governance goals. Demyst supports enterprise external data management with a market leading product and managed service to empower your central data teams, and analytics and business stakeholders across the enterprise."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-25",
                masthead: {
                    title: "Our history and future",
                    subtitle: [
                        "We started in 2010 upon realizing that, while the world is supposedly awash with data,             very little of it is being used for customer benefit. 80% of analytics projects failed             at the ideation, discovery, or deployment phase, with true business impact rarely             realized despite the clear possibilities.",
                        "We have evolved a technology platform that underpins our service, enabling us to             partner closely with the most innovative organizations to collaboratively take on the             most detailed aspects of their data projects. Over 100 of the most exacting banks and             insurers have discovered and deploy the world's best external data through Demyst for             any and all of their use cases including KYC, credit, risk, marketing and more.", 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "white",
                type: "one-col",
                masthead: {
                    title: "The Demyst Executive Team"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (About_module_default()).Team,
                        children: execTeam.map(function(p) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (About_module_default()).Exec,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (About_module_default()).Image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: p.img.src,
                                            alt: p.name,
                                            width: "356",
                                            height: "420",
                                            layout: "responsive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                        className: (About_module_default()).Name,
                                        type: "h3",
                                        children: p.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                        className: (About_module_default()).Role,
                                        asParagraph: true,
                                        type: "h4",
                                        children: p.role
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: p.linkedin,
                                        isExternal: true,
                                        className: (About_module_default()).Linkedin,
                                        title: "View Linkedin Account",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiLinkedin */.qOw, {
                                            alt: "Linkedin Icon"
                                        })
                                    })
                                ]
                            }, p.name);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "violet-900",
                type: "one-col",
                masthead: {
                    title: "Our market",
                    subtitle: [
                        "Current geography list: Australia, Austria, Brazil, Canada, India, Pakistan, Philippines, Singapore, South Africa, Ukraine, United Arab Emirates, United States.", 
                    ]
                },
                removeBottomPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (About_module_default()).Earth,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationMap, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "violet-900",
                type: "three-col",
                masthead: {
                    title: "Our offices"
                },
                children: locations.map(function(l) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (About_module_default()).Location,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMapPin */.i63, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeading */.OT, {
                                    children: l.city
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* SectionParagraph */.Lo, {
                                    children: [
                                        l.address,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        l.address2
                                    ]
                                })
                            ]
                        })
                    }, l.city);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-800",
                type: "one-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta/* BottomCta */.W, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-1000",
                removeBottomPadding: true,
                removeTopPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityBadges/* SecurityBadges */.U, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
;// CONCATENATED MODULE: ./pages/about-us.jsx




var AboutUsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/about-us",
                title: meta/* meta.about.title */.$.about.title,
                description: meta/* meta.about.description */.$.about.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ }),

/***/ 4898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Team":"About_Team__Xo8Pg","Exec":"About_Exec__y5ds_","Image":"About_Image__yx65m","Name":"About_Name__FszWE","Role":"About_Role__xrTSg","Loc":"About_Loc__C8cp3","Linkedin":"About_Linkedin__KG_fj","Location":"About_Location__aW9qC","Earth":"About_Earth__7HJMj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,5675,9223,4280,3295,9774,2888,179], function() { return __webpack_exec__(1840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);